<template>
  <div>
    <div class="form-container ou-donation-form form--minyan">
      <div class="holder">
        <PaymentForm class="form-horizontal">
          <AmountSelectorHauerMemorial v-model:selected-description="selectedDescription" v-model:selected-amount="selectedAmount" />
          <ErrorLabel field="amount" />
          <TransactionFee />
          <FormSection title="Personal Information">
            <FormRow inline>
              <FormCol field="title" :flex="1" />
              <FormCol field="firstName" :flex="2" />
              <FormCol field="lastName" :flex="2" />
            </FormRow>
            <FormRow inline>
              <FormCol field="email" />
              <FormCol field="phone" />
            </FormRow>
            <FormRow inline>
                      <Consent privacy="https://www.ou.org/privacy-policy/"/>
                  </FormRow>             
            <br />
            <InHonorOf />
          </FormSection>
          <FormSection title="Billing Information">
            <DonorAddress />
          </FormSection>
          <FormSection title="Payment Information" last>
            <FormRow inline>
              <FormCol field="card" :showLabel="false" />
            </FormRow>
          </FormSection>
          <PaymentButton showAmount btnText="Donate" />
        </PaymentForm>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, computed } from "vue";
import { usePaymentForm } from "~/shared/use-payment-form";
import { queryParams } from "~/shared/query-params";
import AmountSelectorHauerMemorial from "./amount-selector-hauer-memorial.vue";

export default defineComponent({
  components: {},
  setup(props) {
    const { form } = usePaymentForm();
    const selectedDescription = ref('');
    const selectedAmount = ref(null);

    const show180Message = computed(() => {
      return selectedAmount.value === 180 && selectedDescription.value === 'Dedication with 140-character message';
    });

    // campign for books - Rabbi Hauer Book of Biographies

    return {
      form,
      selectedDescription,
      selectedAmount,
      show180Message,
    };
  },
});
</script>
<style scoped lang="scss">
.form-container.ou-donation-form.form--minyan {
  background-color: white;
  margin: 20px auto;
  border: none;
  box-shadow: none;
}

::v-deep h2{
        color: #133271;
}


h2.payment-heading {
  display: flex;
  justify-content: space-between;
}
.card-img {
  display: flex;
  img {
    height: 23px;
  }
}
.fee-total {
  margin-bottom: 0;
  justify-content: space-between;
}

.custom__messaging {
  margin-top: 20px;
}

.char-count {
  font-size: 12px;
  color: #666;
  text-align: right;
  margin-top: 5px;
}
</style>
